module.exports = __webpack_public_path__ + "static/media/LinkedIn.0c2099ad.svg";